export enum ConsentTypes {
  CREDIT = 1,
  ECOMMUNICATION = 2,
  MOBILE = 3,
  TERMS_AND_CONDITIONS = 4,
  EMAIL_VALIDATION = 5,
  SOFT_PULL = 6,
  REFI_UNDERPAYMENT = 7,
  PARENT_ATTESTATION = 13,
}

export enum ConsentServiceEntityTypes {
  Application = 1,
  Loan = 2,
  Draw = 3,
}

export class ConsentTypeIds {
  public static get CREDIT(): number {
    return ConsentTypes.CREDIT;
  }

  public static get ECOMMUNICATION(): number {
    return ConsentTypes.ECOMMUNICATION;
  }

  public static get MOBILE(): number {
    return ConsentTypes.MOBILE;
  }

  public static get TERMS_AND_CONDITIONS(): number {
    return ConsentTypes.TERMS_AND_CONDITIONS;
  }

  public static get EMAIL_VALIDATION(): number {
    return ConsentTypes.EMAIL_VALIDATION;
  }

  public static get SOFT_PULL(): number {
    return ConsentTypes.SOFT_PULL;
  }
  public static get REFI_UNDERPAYMENT(): number {
    return ConsentTypes.REFI_UNDERPAYMENT;
  }
  public static get PARENT_ATTESTATION(): number {
    return ConsentTypes.PARENT_ATTESTATION;
  }
}

export class ConsentServiceEntityTypeIds {
  public static get Application(): number {
    return ConsentServiceEntityTypes.Application;
  }
  public static get Loan(): number {
    return ConsentServiceEntityTypes.Loan;
  }
  public static get Draw(): number {
    return ConsentServiceEntityTypes.Draw;
  }
}

export interface ConsentFormRequest {
  id?: number;
  consentTypeId: number;
  consentGiven: boolean;
  personId: number;
  entityId: number;
  entityTypeId: number;
  userId?: string;
}

export interface ConsentType {
  id: number;
  createdBy?: string;
  createdAtUtc?: Date;
  description?: string;
  isDeleted: boolean;
  modifiedBy?: string;
  modifiedAt?: Date;
  name?: string;
}

export interface ConsentForm {
  id: number;
  personId: number;
  entityId: number;
  entityTypeId: number;
  entityType?: ConsentType;
  consentType?: ConsentType;
  consentTypeId: number;
  consentGiven: boolean;
  createdAtUtc?: Date;
  createdBy?: string;
  isDeleted: boolean;
  modifiedAt?: Date;
  modifiedBy?: string;
  userId?: string;
}

export interface ConsentFormVM {
  id: number;
	consentedBy: string;
  personId: number;
  personName: string;
  entityId: number;
  entityTypeId: number;
  entityType?: ConsentType;
  consentType?: ConsentType;
  consentTypeId: number;
  consentGiven: boolean;
  createdAtUtc?: Date;
	createdAtDisplay: string;
  createdBy?: string;
  isDeleted: boolean;
  modifiedAt?: Date;
	modifiedAtDisplay: string | null;
  modifiedBy?: string;
  userId?: string;
}
